import { render, staticRenderFns } from "./EventRecordListAdd.vue?vue&type=template&id=72bbb88c&scoped=true"
import script from "./EventRecordListAdd.vue?vue&type=script&lang=js"
export * from "./EventRecordListAdd.vue?vue&type=script&lang=js"
import style0 from "./EventRecordListAdd.vue?vue&type=style&index=0&id=72bbb88c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bbb88c",
  null
  
)

export default component.exports